import { Component } from '@angular/core';

@Component({
  selector: 'app-boutiquehub-button',
  imports: [],
  templateUrl: './boutiquehub-button.html',
  styleUrl: './boutiquehub-button.scss',
})
export class BoutiquehubButton {

}
